import React from 'react';
import { Check } from 'lucide-react';
export function RevelationSection() {
  return <section className="bg-dark py-28 md:py-32 px-4" data-id="element-201">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center text-center" data-id="element-202">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-textLight mb-12" data-id="element-203">
          No todo lo que haces suma.
        </h2>

        <div className="text-lg md:text-xl text-textLight mb-12 space-y-6 max-w-3xl leading-relaxed text-left md:text-center" data-id="element-204">
          <p data-id="element-205">No es tu tiempo. Es en qué lo estás usando.</p>
          <p data-id="element-206">
            Llevas años sosteniendo actividades que no están construyendo tu
            crecimiento. Cada una, por sí sola, parece inofensiva. Juntas son
            una hemorragia silenciosa.
          </p>
          <p data-id="element-207">
            Las llamo fugas porque es lo que son: pérdidas invisibles que drenan
            algo cada día — tiempo, energía, foco, dinero, vida. Y tienen un
            costo real:
          </p>
        </div>

        <div className="flex flex-col items-start text-left gap-6 mb-20 w-full max-w-2xl mx-auto" data-id="element-208">
          <div className="flex items-start gap-4" data-id="element-209">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-210" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-211">
              Menos ingresos de los que deberías estar generando.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-212">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-213" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-214">
              Menos claridad para tomar las decisiones que sí mueven tu negocio.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-215">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-216" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-217">
              Menos vida — meses al año que no vas a recuperar.
            </span>
          </div>
        </div>

        <div className="w-full max-w-4xl mx-auto mt-8" data-id="element-218">
          <p className="font-serif italic text-3xl md:text-5xl text-accent font-bold leading-tight" data-id="element-219">
            "Lo que no se corrige, se repite."
          </p>
        </div>
      </div>
    </section>;
}